export const prepareFullMutationData = (newOption) => {
	// numbers used in switch case below are just harcoded values that are used if skr 03 or skr 04 is selected
	switch(newOption) {
		case 1:
			return({
				savedChartOfAccounts: newOption,
				clientNum: null,
				costCentre: null,
				passAccount: null,
				cashRegisterAccount: null,
				cashRegisterAccountDifference: null,
				cashRegisterAccountDifferenceNegative: null,
				cashRegisterAccountTransfer: null,
				accountPrepaidCard: null,
				accountPrepaidCardLoad: null,
				accountPrepaidCardDiscount: null,
				incomeAccount: [ null, null, null ]
			})
		case 2:
			return({
				savedChartOfAccounts: newOption,
				clientNum: null,
				costCentre: null,
				passAccount: '1360',
				cashRegisterAccount: '1000',
				cashRegisterAccountDifference: '2709',
				cashRegisterAccountDifferenceNegative: '2309',
				cashRegisterAccountTransfer: '1200',
				accountPrepaidCard: '1792',
				accountPrepaidCardLoad: '1792',
				accountPrepaidCardDiscount: '8770',
				incomeAccount: [ '8300', '8400', '8100' ]
			})
		case 3:
			return({
				savedChartOfAccounts: newOption,
				clientNum: null,
				costCentre: null,
				passAccount: '1460',
				cashRegisterAccount: '1600',
				cashRegisterAccountDifference: '4839',
				cashRegisterAccountDifferenceNegative: '6969',
				cashRegisterAccountTransfer: '1700',
				accountPrepaidCard: '3786',
				accountPrepaidCardLoad: '3786',
				accountPrepaidCardDiscount: '4770',
				incomeAccount: [ '4300', '4400', '4100' ]
			})
		default:
			return {}
	}
}

const prepareMutationData = (vals, category, indexes) => {
	switch(category) {
		case 'general':
			return({
				clientNum: vals?.[0]?.value,
				costCentre: vals?.[1]?.value,
				passAccount: vals?.[2]?.value,
				cashRegisterAccount: vals?.[3]?.value,
				cashRegisterAccountDifference: vals?.[4]?.value,
				cashRegisterAccountDifferenceNegative: vals?.[5]?.value,
				cashRegisterAccountTransfer: vals?.[6]?.value
			})
		case 'creditCards':
			return({
				credit: fillingEmptiness(vals, indexes)
			})
		case 'accountPrepaidCard':
			return({
				accountPrepaidCard: vals?.[0]?.value,
				accountPrepaidCardLoad: vals?.[1]?.value,
				accountPrepaidCardDiscount: vals?.[2]?.value
			})
		case 'salesNames':
			return({
				incomeAccount: vals.map(el => el.value)
			})

		default:
			return null
	}
}

const fillingEmptiness = (values, indexes) => {
	let fullArray = []
	values.forEach((el, i) => {
		fullArray[indexes[i]] = el.value
	})
	return(fullArray)
}

export default prepareMutationData
